module.exports = __webpack_public_path__ + "img/深圳湾万科总部大厦.ab6920f8.png";